(function () {
  if (window.__nexusVvideoInit) return;
  window.__nexusVvideoInit = true;

  const roots = Array.from(document.querySelectorAll("[data-nexus-vvideo]"));
  if (!roots.length) return;

  function playAll(root) {
    root.querySelectorAll("video").forEach(function (video) {
      video.play().catch(function () {});
    });
  }

  function pauseAll(root) {
    root.querySelectorAll("video").forEach(function (video) {
      video.pause();
    });
  }

  if (!("IntersectionObserver" in window)) {
    roots.forEach(playAll);
    return;
  }

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio >= 0.25) playAll(entry.target);
        else pauseAll(entry.target);
      });
    },
    { threshold: [0, 0.25, 0.6] }
  );

  roots.forEach(function (root) {
    observer.observe(root);
  });
})();
